function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React from "react";
import SocialMemberBubble from "../containers/SocialMemberBubble";
import PrintNotesButton from "../containers/PrintNotes";
import isFunction from "lodash/isFunction";
import classNames from "classnames";
import Icon from "./Icon";
import { injectIntl } from "react-intl";
import { getAllTopicsForGroupChronologically } from "../utils/SocialTopicsUtils";
import { getNotesChronologically } from "../utils/SocialNotesUtils";
var _React_Component;
// This component is used to render both topics and notes, depending whether it used
// inside SocialApp (for topics) or inside SocialNotesApp (for notes)
var SocialTopics = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(SocialTopics, _superClass);
    var _super = _createSuper(SocialTopics);
    function SocialTopics() {
        _classCallCheck(this, SocialTopics);
        var _this;
        _this = _super.apply(this, arguments);
        _this.renderTopicOrNote = function(topicOrNote) {
            var intl = _this.props.intl;
            var userClasses = classNames("social-topics__topic-user", {
                "user-inactive": topicOrNote.owner.is_active === false
            });
            var userTooltip = topicOrNote.owner.is_active === false ? intl.formatMessage({
                id: "social.users.inactive_title",
                defaultMessage: "inactive"
            }) : "";
            var topicClasses = classNames("social-topics__item", {
                "social-topics__item--unread": !!topicOrNote.unread
            });
            var lastUpdate = topicOrNote.last_activity_at ? topicOrNote.last_activity_at : topicOrNote.created_at;
            return /*#__PURE__*/ React.createElement("li", {
                key: topicOrNote.id,
                className: topicClasses,
                "data-unread-count": topicOrNote.unread
            }, /*#__PURE__*/ React.createElement("button", {
                className: "social-topics__link",
                onClick: _this._onSelectTopicOrNote(topicOrNote)
            }, /*#__PURE__*/ React.createElement("div", {
                className: "social_topics__topic-head"
            }, /*#__PURE__*/ React.createElement(SocialMemberBubble, {
                members: _this.props.sphere.members,
                isNote: _this.props.isNotes,
                indicator: topicOrNote.unread
            }), /*#__PURE__*/ React.createElement("strong", {
                className: "social_topics__topic-title",
                title: topicOrNote.title
            }, topicOrNote.title), /*#__PURE__*/ React.createElement("span", {
                className: userClasses,
                title: userTooltip
            }, !_this.props.sphere.note ? intl.formatMessage({
                id: "social.activities.created_by_",
                defaultMessage: "created by"
            }) + " " + topicOrNote.owner.name.split(" ")[0] : intl.formatMessage({
                id: "social.activities.created_by_me",
                defaultMessage: "me"
            }))), /*#__PURE__*/ React.createElement("div", {
                className: "social_topics__topic-teaser"
            }, topicOrNote.teaser), /*#__PURE__*/ React.createElement("div", {
                className: "social_topics__topic-meta"
            }, topicOrNote.assets ? /*#__PURE__*/ React.createElement("span", {
                className: "social_topics__topic-attachments"
            }, /*#__PURE__*/ React.createElement(Icon, {
                name: "attachment",
                size: "s"
            }), intl.formatMessage({
                id: "social.activities._title_assets_",
                defaultMessage: "assets {assetCount}"
            }, {
                assetCount: topicOrNote.assets
            })) : null, /*#__PURE__*/ React.createElement("span", {
                className: "social_topics__topic-updated"
            }, intl.formatRelative(1000 * lastUpdate)))));
        };
        _this._onSelectTopicOrNote = function(topicOrNote) {
            var _this_props = _this.props, sphere = _this_props.sphere, selectNote = _this_props.selectNote, selectTopic = _this_props.selectTopic, onSelect = _this_props.onSelect;
            return function(evnt) {
                evnt.preventDefault();
                if (sphere.note) {
                    selectNote(topicOrNote);
                } else if (topicOrNote) {
                    selectTopic(topicOrNote);
                }
                onSelect(topicOrNote);
            };
        };
        _this._onCreateNew = function(evnt) {
            evnt.preventDefault();
            if (isFunction(_this.props.onCreate)) {
                _this.props.onCreate();
            }
        };
        _this._onEditSphere = function(sphere) {
            var isInfoView = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var onEdit = _this.props.onEdit;
            return function(evnt) {
                if (evnt && evnt.preventDefault) {
                    evnt.preventDefault();
                    evnt.stopPropagation();
                }
                if (isFunction(onEdit)) {
                    onEdit(sphere, isInfoView);
                }
            };
        };
        return _this;
    }
    var _proto = SocialTopics.prototype;
    _proto.render = function render() {
        var _this_props = this.props, className = _this_props.className, intl = _this_props.intl, isGroupManagementAllowed = _this_props.isGroupManagementAllowed, currentUser = _this_props.currentUser, sphere = _this_props.sphere, notes = _this_props.notes, topics = _this_props.topics, isNotes = _this_props.isNotes, noteFilter = _this_props.noteFilter;
        var topicsOrNotes = this._getTopicsOrNotes(sphere, notes, topics);
        var classes = classNames("social-topics", {
            "social-topics--short": sphere.note
        });
        var canEditGroup = !!isGroupManagementAllowed && !!currentUser && sphere.owner.id === currentUser.id && sphere.is_visible;
        return /*#__PURE__*/ React.createElement("div", {
            className: className
        }, /*#__PURE__*/ React.createElement("div", {
            className: "social-app-options"
        }, !isNotes ? canEditGroup ? /*#__PURE__*/ React.createElement("button", {
            className: "social-app-options__btn social-app-options__btn--secondary social-app-options__btn--left",
            onClick: this._onEditSphere(sphere)
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "edit",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "social-app-options__btn-text"
        }, intl.formatMessage({
            id: "social.activities.group_edit",
            defaultMessage: "edit group"
        }))) : /*#__PURE__*/ React.createElement("button", {
            className: "social-app-options__btn social-app-options__btn--secondary social-app-options__btn--left",
            onClick: this._onEditSphere(sphere, true)
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "share",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "social-app-options__btn-text"
        }, intl.formatMessage({
            id: "social.activities.group_info",
            defaultMessage: "group info"
        }))) : null, /*#__PURE__*/ React.createElement("button", {
            onClick: this._onCreateNew,
            className: "social-app-options__btn icon-plus icon-plus--white"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "add",
            size: "m"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "social-app-options__btn-text"
        }, !sphere.note ? intl.formatMessage({
            id: "social.activities._create_new_topic",
            defaultMessage: "create new topic"
        }) : intl.formatMessage({
            id: "social.notes.new_note",
            defaultMessage: "new note"
        }))), isNotes && !!topicsOrNotes.length && /*#__PURE__*/ React.createElement(PrintNotesButton, {
            nodeIds: noteFilter || []
        })), topicsOrNotes.length ? /*#__PURE__*/ React.createElement("ul", {
            className: classes
        }, topicsOrNotes.map(this.renderTopicOrNote)) : /*#__PURE__*/ React.createElement("p", {
            className: "social-app-no-communication"
        }, intl.formatMessage({
            id: sphere.note ? "social.activities._no_notes" : "social.activities._no_communication",
            defaultMessage: "nothing there yet"
        })));
    };
    _proto._getTopicsOrNotes = function _getTopicsOrNotes(sphere, notes, topics) {
        return sphere.note ? getNotesChronologically(notes) : getAllTopicsForGroupChronologically(sphere, topics);
    };
    return SocialTopics;
}(_React_Component = React.Component);
SocialTopics.displayName = "SocialTopics";
export default injectIntl(SocialTopics);
